import { useEffect, useState } from 'react';
import {
  getManageableCommunityPosts,
  getPublishedCommunityPosts,
} from '../services/communityPostsService';

export function useCommunityPosts(mode) {
  const [posts, setPosts] = useState([]);
  const [status, setStatus] = useState('idle'); // idle | loading | success | error
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setStatus('loading');
      setErrorMessage('');
      try {
        const rows =
          mode === 'manage' ? await getManageableCommunityPosts() : await getPublishedCommunityPosts();
        if (cancelled) return;
        setPosts(rows);
        setStatus('success');
      } catch (e) {
        if (cancelled) return;
        setPosts([]);
        setStatus('error');
        setErrorMessage(e?.message || 'Failed to load posts');
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [mode]);

  return { posts, status, errorMessage, setPosts };
}

